import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../../Config";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// Function to fetch data from the API
const getSpotRegistrationData = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}/delegetListwithActivity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const SingleDelefateActivityView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { Activity_Name, Activity_Type_ID } = location.state || {};
  const [data, setData] = useState([]);
  const [checkInCount, setCheckInCount] = useState([]);
  const [pagination, setPagination] = useState({
    totalRecords: 0,
    currentPage: 1,
    totalPages: 1,
    pageSize: 25,
  });
  const [search, setSearch] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch data from API
  const fetchData = async () => {
    const payload = {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      action_type: "",
      search: search,
      action_type: Activity_Type_ID,
    };

    try {
      const response = await getSpotRegistrationData(payload);
      setData(response.data || []);

      // Check if response.pagination exists
      if (response.pagination) {
        setPagination(response.pagination);
      } else {
        // If pagination info not provided by API, derive from response
        setPagination((prev) => ({
          ...prev,
          totalRecords: response.data?.length || 0,
          totalPages: 1, // Or calculate manually if backend doesn't support pagination
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Trigger fetch data on page change, page size change, or search change
  useEffect(() => {
    fetchData();
  }, [pagination.currentPage, pagination.pageSize, search]);

  const GetCheckinCount = async (userId) => {
    try {
      // Send request
      const res = await axios.post(`${BASE_URL}/getActionTypeCount`);
      setCheckInCount(res?.data?.data?.count);
    } catch (error) {
      console.error(error);

      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Unable to send mail. Please try again.",
      });
    }
  };
  useEffect(() => {
    GetCheckinCount();
  }, []);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handlePageSizeChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      pageSize: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
  };

  const handleLogout = () => {
    // Clear user session or authentication data
    sessionStorage.clear(); // or localStorage.clear();

    // Redirect to the homepage
    navigate("/admin/login");
  };

  const handleExportExcel = () => {
    const exportData = data.map((item) => {
      const activity = item.actions?.find(
        (a) => a.action_type === Activity_Type_ID
      );
      const activityDate = activity
        ? new Date(activity.date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        : "-";

      return {
        "Batch No": item.id,
        Name: item.name,
        Mobile: item.mobile,
        Company:
          item.organization_name ||
          item?.deletegate_registation?.organization_name,
        [Activity_Name]: activity ? "Yes" : "No",
        "Activity Date & Time": activityDate,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Delegates");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, `${Activity_Name}_Delegates.xlsx`);
  };

  return (
    <div id="page" className="page">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button
          style={{
            background: "#44929f",
            padding: "6px 20px",
            borderRadius: "40px",
            fontSize: "16px",
            fontWeight: 600,
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => navigate("/dashboard/activitiest")}
        >
          Back
        </button>

        <button
          style={{
            background: "#28a745",
            padding: "6px 20px",
            borderRadius: "40px",
            fontSize: "16px",
            fontWeight: 600,
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
          onClick={handleExportExcel}
        >
          Export to Excel
        </button>

        <button
          style={{
            background: "#dc3545",
            padding: "6px 20px",
            borderRadius: "40px",
            fontSize: "16px",
            fontWeight: 600,
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
      <div className="inner-page-wrapper">
        <section className="division wide-30">
          <div className="container">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h4 style={{ fontWeight: 700 }} className="font-bold">
                      {Activity_Name}
                    </h4>
                    {/* Entries and Search UI */}
                    <div className="d-flex flex-column p- flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 mt-3 gap-3">
                      <div>
                        Show{" "}
                        <select
                          className="form-select d-inline-block w-auto border"
                          value={pagination.pageSize}
                          onChange={handlePageSizeChange}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                        </select>{" "}
                      </div>
                      <div className={` ${!isMobile ? "w-80" : "w-100"}`}>
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                      <table
                        id="request-list"
                        className="table table-bordered"
                        style={{ width: "100%" }}
                        data-order='[[0,"desc"]]'
                      >
                        <thead>
                          <tr className="text-center">
                            <th>Batch NO.</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Company</th>
                            <th>{Activity_Name}</th>
                            <th>Activity Date & Time</th>
                            {/* <th>Activity Date</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item) => (
                            <tr key={item.id} className="text-center">
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.mobile}</td>
                              <td>
                                {item.organization_name ||
                                  item?.deletegate_registation
                                    ?.organization_name}
                              </td>

                              <td>
                                {item.actions?.some(
                                  (a) => a.action_type === Activity_Type_ID
                                )
                                  ? "Yes"
                                  : "No"}
                              </td>
                              {item.actions?.length > 0 ? (
                                item.actions.map((a, i) => {
                                  const actionDate = new Date(
                                    a.date
                                  ).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                  });

                                  const updatedDate = new Date(
                                    a.updatedAt
                                  ).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                  });

                                  return (
                                    <React.Fragment key={i}>
                                      <td>{actionDate}</td>
                                      {/* <td>{updatedDate}</td> */}
                                    </React.Fragment>
                                  );
                                })
                              ) : (
                                <>
                                  <td>-</td>
                                  {/* <td>-</td> */}
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-5">
                      <div className="mb-3 mb-md-0">
                        Showing{" "}
                        {(pagination.currentPage - 1) * pagination.pageSize + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.currentPage * pagination.pageSize,
                          pagination.totalRecords
                        )}{" "}
                        of {pagination.totalRecords} entries
                      </div>

                      <nav>
                        <ul className="pagination mb-0 flex-wrap">
                          {/* Previous button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage - 1)
                              }
                              disabled={pagination.currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page numbers with ellipsis */}
                          {Array.from(
                            { length: pagination.totalPages },
                            (_, i) => i + 1
                          )
                            .filter(
                              (page) =>
                                page === 1 ||
                                page === pagination.totalPages ||
                                (page >= pagination.currentPage - 2 &&
                                  page <= pagination.currentPage + 2)
                            )
                            .map((page, idx, arr) => {
                              const prevPage = arr[idx - 1];
                              const showEllipsis =
                                prevPage && page - prevPage > 1;
                              return (
                                <React.Fragment key={page}>
                                  {showEllipsis && (
                                    <li className="page-item disabled">
                                      <span className="page-link">…</span>
                                    </li>
                                  )}
                                  <li
                                    className={`page-item ${
                                      pagination.currentPage === page
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => handlePageChange(page)}
                                    >
                                      {page}
                                    </button>
                                  </li>
                                </React.Fragment>
                              );
                            })}

                          {/* Next button */}
                          <li
                            className={`page-item ${
                              pagination.currentPage === pagination.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() =>
                                handlePageChange(pagination.currentPage + 1)
                              }
                              disabled={
                                pagination.currentPage === pagination.totalPages
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SingleDelefateActivityView;
